import { YardiVoyagerConnectForm } from './YardiVoyagerConnectForm'
import type { VendorConnectorProps } from './types'

export function YardiVoyagerConnector({ onConnected }: VendorConnectorProps) {
  return <YardiVoyagerConnectForm onConnected={() => onConnected?.()} />
}
